/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Record_DismissInputs */

const en_us2_workout_live_record_dismiss = /** @type {(inputs: Workout_Live_Record_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const pt_br2_workout_live_record_dismiss = /** @type {(inputs: Workout_Live_Record_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const es_419_workout_live_record_dismiss = /** @type {(inputs: Workout_Live_Record_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const pt_pt2_workout_live_record_dismiss = /** @type {(inputs: Workout_Live_Record_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const fr_fr2_workout_live_record_dismiss = /** @type {(inputs: Workout_Live_Record_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_de2_workout_live_record_dismiss = /** @type {(inputs: Workout_Live_Record_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const it_it2_workout_live_record_dismiss = /** @type {(inputs: Workout_Live_Record_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Workout_Live_Record_DismissInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_record_dismiss = /** @type {((inputs?: Workout_Live_Record_DismissInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Record_DismissInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_record_dismiss(inputs)
	if (locale === "es-419") return es_419_workout_live_record_dismiss(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_record_dismiss(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_record_dismiss(inputs)
	if (locale === "de-DE") return de_de2_workout_live_record_dismiss(inputs)
	if (locale === "it-IT") return it_it2_workout_live_record_dismiss(inputs)
	return en_us2_workout_live_record_dismiss(inputs)
});
export { workout_live_record_dismiss as "workout-live.record_dismiss" }